<template>
  <div class="wrapper">
    <div class="searchBar">
      <el-input
        class="searchInput"
        size="small"
        placeholder="报名名称"
        v-model="searchCondition.testName"
        clearable
      >
      </el-input
      >&emsp;
      <el-button
        type="primary"
        size="small"
        icon="el-icon-search"
        @click="getPassScoreList()"
        >查询
      </el-button>
    </div>
    <div class="tableContainer">
      <Table :columns="columns" :data="paperScoreSettingList" border>
        <template slot-scope="{ row, index }" slot="action">
          <div>
            <el-link type="primary" @click="openDialog(row)"
              >{{ row.score }}
            </el-link>
          </div>
        </template>
      </Table>

      <el-dialog
        title="修改及格分数"
        :visible.sync="dialogFormVisible"
        append-to-body
        width="20%"
        @closed="Object.assign(scoreData, $options.data().scoreData)"
      >
        <el-form :model="scoreData">
          <el-input
            v-model="scoreData.score"
            autocomplete="off"
            onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"
          ></el-input>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="editPassScore()">确 定</el-button>
        </div>
      </el-dialog>

      <!--分页-->

      <el-row>
        <el-col :span="24">
          <div class="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="paginations.page_index"
              :page-sizes="paginations.page_sizes"
              :page-size.sync="paginations.page_size"
              :layout="paginations.layout"
              :total="paginations.total"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getPassScoreList, editPassScore } from "@/api/paper.js";

export default {
  data() {
    return {
      dialogFormVisible: false,
      scoreData: {
        id: "",
        score: "",
      },
      paginations: {
        page_index: 1, //当前页
        page_size: 30, //每页多少条
        total: 30,
        page_sizes: [10, 15, 30, 50],
        layout: "total,sizes, prev, pager, next,jumper",
      },
      searchCondition: {
        pageSize: 30,
        jumpPage: 1,
        testName: "",
      },
      columns: [
        // {
        //   type: "selection",
        //   width: 60,
        //   align: "center",
        //   key: "choose",
        // },
        {
          title: "序号",
          type: "index",
          width: 70,
        },
        {
          title: "报名名称",
          key: "testName",
        },

        {
          title: "报名方式",
          key: "source",
        },
        {
          title: "及格分数",
          slot: "action",
          key: "score",
        },
        {
          title: "创建时间",
          key: "createTime",
        },
      ],
      paperScoreSettingList: [],
    };
  },
  created() {},
  mounted() {
    this.getPassScoreList();
  },
  methods: {
    handleSizeChange(page_size) {
      console.log(`每页 ${page_size} 条`);
      this.paginations.page_size = page_size;
      this.searchCondition.pageSize = page_size;
      this.getPassScoreList();
    },
    handleCurrentChange(page) {
      console.log(`当前页: ${page}`);
      this.paginations.page_index = page;
      this.searchCondition.jumpPage = page;
      this.getPassScoreList();
    },

    getPassScoreList() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getPassScoreList(this.searchCondition).then((data) => {
        console.log("paperScoreSettingList结果", data);
        this.paperScoreSettingList = data.records;
        this.paginations.total = data.total;
      });
    },
    editPassScore(item) {
      console.log("hahahha", item);
      editPassScore(this.scoreData).then((data) => {
        console.log("paperScoreSettingList结果", data);
        this.getPassScoreList();
      });

      this.dialogFormVisible = false;
    },
    openDialog(item) {
      this.scoreData.id = item.id;
      this.dialogFormVisible = true;
    },

    checkNum() {
      var score = this.scoreData.score;
      score = score.replace(/[^\d]/g, ""); // 清除“数字”和“.”以外的字符
      if (score.indexOf(".") < 0 && score != "") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        score = parseInt(score);
      }
      this.score = score;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  font-size: 12px;
  margin: 15px;
  padding: 20px;

  .searchBar {
    .searchInput {
      width: 20%;
    }
  }

  .tableContainer {
    padding-top: 20px;
    background: #fff;
  }
}
</style>